import util from '../lib/util';
import * as DateUtil from '../lib/dateutils';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class Blackout extends Base implements EntityType {
    blackoutId: uuid;
    userId: uuid;
    startDate?: Date | null;
    endDate?: Date | null;
    reason: uuid;
    constructor(doc: typeof Blackout | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            blackoutId: genUUID(),
            userId: null,
            reason: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "blackout";
        // @ts-ignore
        this.blackoutId = doc._blackoutId || doc.blackoutId || doc.blackoutid || genUUID();
        // @ts-ignore
        this.userId = doc._userId || doc.userId || doc.userid || null;
        // @ts-ignore
        this.startDate = DateUtil.dateOnly(doc._startDate) || DateUtil.dateOnly(doc.startDate) || DateUtil.dateOnly(doc.startdate) || null;
        // @ts-ignore
        this.endDate = DateUtil.dateOnly(doc._endDate) || DateUtil.dateOnly(doc.endDate) || DateUtil.dateOnly(doc.enddate) || null;
        // @ts-ignore
        this.reason = doc._reason || doc.reason || null;
    }
    get id(): uuid { return this.blackoutId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for a blackout"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.blackoutId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Blackout[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'blackout',
    table: 'BLACKOUT',
    comment: 'A court blackout specifies dates where a user is either in, or preparing for, court.  This is used for calendaring purposes, to block off time where the user should not be scheduled.',
    fields: {
        blackoutId: {
            type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for a blackout'
        },

        userId: {
            type: 'uuid', entityType: 'user', required: true, comment: 'The user with the blackout period'
        },

        startDate: {
            type: 'date', comment: 'Date that the blackout starts'
        },

        endDate: {
            type: 'date', comment: 'Date that the blackout ends'
        },

        /**
         * A lookup for a reason, such as:
         * - Trial prep
         * - Too many trials on one day
         */
        reason: {
            type: 'uuid',
            entityType: 'lookup',
            lookupPaths: ['blackout:reason'],
            required: true,
            comment: 'Blackout reason'
        }
    },
    maps: [
        {name: 'userId', keysFn: t => t.userId, presentFn: (t, k) => t.userId === k},
        {name: 'reason', keysFn: t => t.reason, presentFn: (t, k) => t.reason === k},
    ]
});
    }
}
export default Blackout;
